export default {

    allowClose: true,
    open: false,
    loading: false,
    iconUrl: null,
    message: null,
    link: {
        url: null,
        title: null
    }

}
